module.exports = __webpack_public_path__ + "static/media/joana_english_yus.0bf1abf6.mp3";